export const buildImageUrlForQuestionAnswer = (question, arrId) => {
  let url = "";
  if (question.answers[arrId].icon && question.answers[arrId].icon.imageUrl) {
    url = question.answers[arrId].icon.imageUrl;
  }
  return url;
};

export const getImageCaptionForQuestionAnswer = (question, arrId) => {
  return question.answers[arrId] &&
    question.answers[arrId].icon &&
    question.answers[arrId].icon.caption
    ? question.answers[arrId].icon.caption
    : "image";
};
